import type { MixinsOptions } from '@mui/material/styles/createMixins';

export const mixins: MixinsOptions = {
  toolbar: {
    height: 70,
    '@media (min-width:600px)': {
      height: 80,
    },
  },
};
